import moment, { Moment } from 'moment';
import { getDateObjectFromString } from '../date';
import { ILine as Line, IStage as Stage } from '../../global';

export function getStartEndOfLines(lines: Array<Line>): {
  start: Moment;
  end: Moment;
} {
  let start = moment.utc().add(10, 'y');
  let end = moment.utc().subtract(10, 'y');
  lines.map((line) =>
    line.stages.forEach((stage) => {
      if (stage.deleted !== true) {
        const date = getDateObjectFromString(stage.start);
        if (date > end) end = date;
        if (date < start) start = date;
      }
    }),
  );
  return { start, end };
}

export function getStartOfLine(stages: Array<Stage>): Moment {
  let start = moment.utc().add(1000, 'y');
  stages.forEach((stage) => {
    const stageStart = getDateObjectFromString(stage.start);
    if (!stage.deleted && start > stageStart) {
      start = stageStart;
    }
  });
  return start;
}

export function getEndOfLine(stages): Moment {
  let end = moment.utc().subtract(1000, 'y');
  stages.forEach((stage) => {
    const stageStart = getDateObjectFromString(stage.start);
    if (!stage.deleted && end < stageStart) {
      end = stageStart;
    }
  });
  return end;
}

export function getLineContainerStartDate(line: Line): Moment {
  return getStartOfLine(line.stages).startOf('M');
}

export function getLineEndDate(line: Line): Moment {
  return getEndOfLine(line.stages).endOf('M');
}
